// ЭКРАН ШАГА 7 — gate + share: gated → received, отказ отправки (E2) и поздний отказ.
// B9-3 `3e619875cbb881e98746cd0e68ffce19` (gated) + B9-4 (отправка, received, отказ).
//
// ИСТОЧНИК — три дома (DoR s961 п. 1, DoR s962): спека s9 (§2 композиция, §3 строки, §4 машина, §5
// плиты и обложка, §8 края, §10 раскладка, §11 правила), борды `docs/design/wizard-s7/` (golden v6 —
// G1 до и после тапа, G2 обложка; edge v9 — E1, E2, E4b, E6/E7, E8, E10 (E12 parked); `Late Send Fail v1` —
// кадр L1 = вариант A),
// handoff. Код пишется по спеке (`s753.d1`); где борды расходятся между собой — по DoR.
//
// ⭐ GATED — ЭТО (спека §2, DoR s961 п. 2):
//   · поле редактируется, плейсхолдер `your@email.com`; send «Send it to me» `off` при `empty`/`invalid`,
//     `on` при `valid` (`s478.d3`). Валидация — `validateEmail` (B9-2) на blur и на паузе в наборе
//     600 мс (`s961.d1`), НЕ на каждое нажатие;
//   · Open тёмно-заблокирован (`s475.d1`): валидация его не гейтит, только send;
//   · блок «what you get» с чипом `[ enter email ]`, обе плиты под пеленой (`scrim`, golden v6 G1);
//   · моста нет (`s472.d5`).
//
// ⭐ ТАП ПО `on` (`s921.d2`) — ХОРЕОГРАФИЯ НА ТАПЕ, ОТВЕТА НЕ ЖДЁТ. Классы на корне экрана — те же, что
// у `.stage` борда, и в том же порядке: `sent` (0 мс: пульс поля 620 мс, send становится квитанцией,
// в поле ✓) → `go` (420 мс: пелена съезжает 520 мс, чип → `[ yours ]`, карточка инертна, мост, Open
// янтарный и живой) → `settled` (2300 мс: ✓ в поле → «Change»). Письмо уходит в фоне тем же тапом;
// исход приходит когда придёт (до 30 с, `SEND_TIMEOUT_MS`). Координаты не меняются: ничего не
// вставляется и не переезжает — два элемента меняют то, чем они являются (send ↔ квитанция, поле ↔
// адрес), и в самом низу появляется мост, под которым ничего нет.
//
// ⭐ ОТКАЗ (E2, `s921.d1`–`d4`) — ЗАБИРАЕТСЯ РОВНО ОДНО УТВЕРЖДЕНИЕ, КВИТАНЦИЯ. `[ yours ]`, живой Open,
// открытые плиты, мост — остаются (Open = второй путь доставки). Вариант A позднего отказа (`s921.d3`,
// кадр L1; ⛔ кадр L3 = вариант B отклонён): 0 мс — квитанция и спам гаснут 160 мс, ✓ в поле → Change ·
// 160 мс — send возвращается ТЕМ ЖЕ контролом (180 мс), строка отказа раскрывается над Open (240 мс) ·
// низ сдвигается вниз ОДИН раз · всё встаёт за ~400 мс. Пришёл раньше 420 мс — пелена доигрывает
// (таймер `go` отказом не снимается). Reduced motion — мгновенно. Ретрай = та же кнопка send.
//
// ⛔ НИ ТОСТА, НИ МОДАЛКИ, НИ СПИННЕРА (§7, §11): статус несёт сам экран, `announce` здесь не зовётся.
// Футера на шаге 7 нет (`s785.d2`, `NO_ROW`), так что и объявлять в `publishGate` нечего.
//
// ⭐ SEND = СЛЕПОК → ПИСЬМО (Supabase, часть 1, п. 5). Тап сохраняет слепок разбора (`makeSnapshot`:
// тот же паспорт, что рисует Open, + дата документа) под токеном и только на успехе зовёт письмо с тем
// же токеном; письмо несёт ссылку `/r/{token}`. Токен и дата живут в памяти шага на ПАСПОРТ: повторный
// тап того же документа — тот же токен, строки не плодятся. Слепок не сохранился → письма нет, `sent:
// false` → E2; черновик стирается только на `sent: true` (`settleSubmit`, `s889.d3`), то есть после обоих.
// Сырые ответы T1–T3 на сервер не едут вовсе — ни в слепке, ни в теле письма; выборы кнопок шага 3 и
// свой ответ BG3 — едут: они напечатаны в §II и часть документа (`s987.d4`, `documentPassport.js`).
//
// ⭐ OPEN — разбор в новом окне из памяти шага (B9-6, `s965.d1`): документ собирает это окно
// (`s7Document.js`, `assembleSections` + `r10*.css` строкой + fit-JS) и отдаёт его `Blob` URL.
// Хранилище новое окно не читает. Метка не меняется (`s475.d1`).
//
// ⭐ КРАЯ B9-5 (edge v9, §8 спеки):
//   · E1 — `invalid`: поле `bad` с ✕, под полем `s7.err.email` и `s7.where_to.microcopy` (дом строки —
//     края, `s755.d1`), send `off`, Open тёмный. Печатается по СТАТУСУ поля, то есть после blur/паузы;
//   · E4b — обложка не готова (фрейм §I ещё не загрузился): пустая плита — пунктир на полном
//     футпринте, ни обложки, ни кривой, тап погашен, чипа `tap` нет, статус `s7.pending.cover`. Фрейм
//     стоит в разметке и грузится, но не виден: обложка появляется уже готовой;
//   · E6/E7 — возврат: обычный received без квитанции (нажатия не было), поле — полный адрес с
//     «Change» (`s755.d2`), Open живой, мост. Источник префилла — data contract (§9), экран от него не
//     зависит: `returning` — адрес, с которым экран встаёт сразу в received.
//
// ⭐ SAVE PDF (строка 67, `s987.d1`): PDF разбора собирается ЗАРАНЕЕ — на маунте шага 7, то есть на выходе
// с шага 6 (последний экран перед разбором; точка заморозки `s442.d1` в нынешнем 7-шаговом флоу). Файл
// держит склад вкладки (`pdfStore.js`), кнопка «Save PDF» стоит в окне Open. Паспорт сменился (возврат и
// правка этапа) — эффект заказывает сборку заново, прежняя выбрасывается.
//
// ⚠️ ПОДПИСИ ЗАГЛУШКИ КАРТОЧКИ (`silhouette · no names`, `placeholder`, чип `tap` — `cardPh()`
// `s7-v4-helpers.js:26`) НЕ ПЕЧАТАЮТСЯ (`s755.d3`). Плита — пустая тёмная коробка той же геометрии.

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { useWizard } from '../WizardProvider.jsx';
import { useDocumentPassport } from '../documentPassport.js';
import { sendEndpoint, sendPassport, tapKey } from '../../send/transport.js';
import { saveSnapshot } from '../../send/snapshot.js';
import { makeSnapshot, newToken } from '../../share/snapshot.js';
import { localIsoDate } from '../../render/docDate.js';
import { BRIDGE_HREF, S7_COPY, S7_TITLE, sentReceipt, validateEmail } from './s7Copy.js';
import { THUMB, coverDoc, coverPageDoc } from './s7Cover.js';
import { openDocument } from './s7Document.js';
import { pdfStore } from '../../pdf/pdfStore.js';

/** Пауза в наборе, после которой поле валидируется (`s961.d1`). */
export const VALIDATE_PAUSE_MS = 600;

// ---- ТАЙМИНГИ ХОРЕОГРАФИИ (`s921.d2`, `s921.d3`) — байт бордов, сверка в `StepSeven.send.test.jsx` ----
/** Пульс поля моссом один раз — `pulseone .62s` (golden v6 `<style>`). */
export const PULSE_MS = 620;
/** `sent` → `go`: пелена трогается — `setTimeout(…'go'…,420)` в `play()` golden v6 и unlock v1. */
export const VEIL_AT_MS = 420;
/** Съезд пелены — `transition: transform .52s` (`.unlock .scrim`). */
export const VEIL_MS = 520;
/** `go` → `settled`: ✓ в поле становится «Change» — `setTimeout(…'settled'…,2300)`. */
export const SETTLE_AT_MS = 2300;
/** Поздний отказ: квитанция и спам гаснут — `transition: opacity .16s`; и момент `fail` — `lfAt(st,160,…)`. */
export const FAIL_FADE_MS = 160;
/** Send возвращается — `animation: lfin .18s` (`Late Send Fail v1`). */
export const FAIL_SEND_IN_MS = 180;
/** Строка отказа раскрывается над Open — `transition: grid-template-rows .24s`. */
export const FAIL_LINE_MS = 240;
/** Пульс чипа `tap` плиты разбора — `tapb 2.6s` (`s7-v4-objects.css`, §5). */
export const TAP_PULSE_MS = 2600;

const prefersReducedMotion = () => typeof window !== 'undefined'
  && typeof window.matchMedia === 'function'
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Квитанция с маской — ТОЛЬКО из адреса, который `validateEmail` признал `valid` (DoR s962). Пустое
 * и неполное в маску не идут вовсе: `null`, а не строка с придуманной формой. Края обрезаются —
 * той же обрезкой, что у валидатора, иначе пробел в начале стал бы «первой буквой» маски.
 */
export function receiptFor(address) {
  if (validateEmail(address) !== 'valid') return null;
  return sentReceipt(String(address).trim());
}

/**
 * Поле адреса и состояние send: значение меняется на каждое нажатие, а СТАТУС валидации — только на
 * blur и после паузы `VALIDATE_PAUSE_MS` (`s961.d1`). Пустое поле на входе — `empty` без прогона.
 */
export function useEmailField(initial = '') {
  const [value, setValue] = useState(initial);
  const [status, setStatus] = useState(() => validateEmail(initial));
  const timer = useRef(null);
  const latest = useRef(initial);

  const onChange = useCallback((e) => {
    const v = e.target.value;
    latest.current = v;
    setValue(v);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setStatus(validateEmail(latest.current)), VALIDATE_PAUSE_MS);
  }, []);
  const onBlur = useCallback(() => {
    clearTimeout(timer.current);
    setStatus(validateEmail(latest.current));
  }, []);
  useEffect(() => () => clearTimeout(timer.current), []);

  return { value, status, onChange, onBlur };
}


const IDLE = {
  taps: 0, address: '', sent: false, go: false, settled: false, failing: false, fail: false, editing: false,
  returning: false,
};

/** E6/E7: экран встаёт сразу в received — объекты открыты, ✓ уже «Change», квитанции нет. */
const returnState = (address) => ({ ...IDLE, address, go: true, settled: true, returning: true });

/**
 * МАШИНА ДОСТАВКИ (§4 спеки, `s921.d1`–`d3`). Флаги — классы `.stage` борда, по одному на кадр:
 *   · `sent`     — квитанция заявлена (тап был, отказа по последнему тапу нет);
 *   · `go`       — объекты открыты: ставится один раз через `VEIL_AT_MS` после ПЕРВОГО тапа и не
 *                  снимается ничем, в том числе отказом (Open = второй путь доставки);
 *   · `settled`  — ✓ в поле сменился на «Change»;
 *   · `failing`  — отказ пришёл, квитанция гаснет; `fail` — через `FAIL_FADE_MS` send вернулся;
 *   · `editing`  — «Change» нажат, поле снова ввод, send рядом.
 *   · `returning` — E6/E7: вход сразу в received по адресу на руках (см. `returnState`).
 * Один тап — ровно один вызов транспорта; ответ старого тапа после нового не применяется.
 *
 * @param {{field:object, send:(input:object)=>Promise<{sent:boolean,reason?:string}>,
 *          settleSubmit:(o:{sent:boolean})=>boolean, payload:()=>object, returning?:string|null}} deps
 */
export function useDelivery({ field, send, settleSubmit, payload, returning = null }) {
  const [st, setSt] = useState(() => (returning ? returnState(returning) : IDLE));
  const timers = useRef({});
  const lastReq = useRef(0);
  const opened = useRef(Boolean(returning));
  const alive = useRef(true);

  useEffect(() => {
    alive.current = true;
    const t = timers.current;
    return () => {
      alive.current = false;
      Object.values(t).forEach(clearTimeout);
    };
  }, []);
  const later = (name, ms, fn) => {
    clearTimeout(timers.current[name]);
    timers.current[name] = setTimeout(fn, ms);
  };

  const onSend = useCallback(() => {
    // Статус поля мог устареть внутри паузы 600 мс: перед отправкой — прогон по самому значению.
    if (validateEmail(field.value) !== 'valid') {
      field.onBlur();
      return;
    }
    const address = String(field.value).trim();
    const id = ++lastReq.current;
    clearTimeout(timers.current.fail);
    setSt((s) => ({
      ...s, taps: s.taps + 1, address, sent: true, settled: false, failing: false, fail: false, editing: false,
    }));
    if (!opened.current) {
      opened.current = true;
      later('go', VEIL_AT_MS, () => setSt((s) => ({ ...s, go: true })));
    }
    later('settled', SETTLE_AT_MS, () => setSt((s) => ({ ...s, settled: true })));

    // Ключ идемпотентности — один на тап (Setup Resend `s973.d1`): Resend по нему второго письма не шлёт.
    const idempotencyKey = tapKey();
    Promise.resolve()
      .then(() => send({ email: address, idempotencyKey, ...payload() }))
      .catch(() => ({ sent: false, reason: 'threw' }))
      .then((outcome) => {
        if (!alive.current || id !== lastReq.current) return;
        const sent = outcome?.sent === true;
        settleSubmit({ sent });
        if (sent) return;
        // Причина — только в лог; адреса в ней нет по построению транспорта (`s946.d3`).
        console.info('[wizard] s7 send failed:', outcome?.reason ?? 'unknown');
        if (prefersReducedMotion()) {
          setSt((s) => ({ ...s, sent: false, failing: true, fail: true }));
          return;
        }
        setSt((s) => ({ ...s, sent: false, failing: true }));
        later('fail', FAIL_FADE_MS, () => setSt((s) => ({ ...s, fail: true })));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.value, field.onBlur, send, settleSubmit, payload]);

  const onChangeAddress = useCallback(() => setSt((s) => ({ ...s, editing: true })), []);

  return { ...st, onSend, onChangeAddress };
}

export default function StepSeven({ pdf = pdfStore }) {
  const { session, settleSubmit, awaitQuotes } = useWizard();
  const passport = useDocumentPassport(session);
  // ⭐ ПЕРВАЯ СБОРКА PDF ЖДЁТ СУДЬЮ (`s998.d3`, вариант Б). Обычный путь сюда — CTA шага 6, она уже дождалась:
  // результат под текущий вход в конверте, ожидание отдаёт его сразу. Старый конверт, сохранённый на шаге 7
  // без результата, иначе собрал бы файл без цитат и пересобрал после фонового ответа — в эти секунды можно
  // было скачать документ без своих цитат. Ждём тот же вызов, что зовёт оболочка (один на ключ); сбой
  // транспорта — тоже исход, сборка идёт, как при сбое сейчас. Повтор записанного сбоя здесь не делаем.
  // Пока ждём, склад в `idle` — кнопка документа Open стоит в «Preparing PDF…» (`buttonView`).
  const [judged, setJudged] = useState(!awaitQuotes);
  useEffect(() => {
    if (!awaitQuotes) return undefined;
    let live = true;
    Promise.resolve(awaitQuotes({ retryFailed: false })).then(() => { if (live) setJudged(true); });
    return () => { live = false; };
  }, [awaitQuotes]);
  useEffect(() => { if (judged) pdf.prebuild(passport, localIsoDate()); }, [judged, pdf, passport]);
  const cover = useMemo(() => coverDoc(passport, THUMB - 2), [passport]);
  // E4b: обложка готова, когда фрейм §I загрузился; до того — пустая плита.
  const [coverReady, setCoverReady] = useState(false);
  const onCoverLoad = useCallback(() => setCoverReady(true), []);
  const field = useEmailField();
  const share = useRef(null);
  const send = useCallback((input) => sendWithSnapshot(input, passport, share), [passport]);
  const payload = useCallback(() => ({}), []);
  const delivery = useDelivery({ field, send, settleSubmit, payload });
  const [coverOpen, setCoverOpen] = useState(false);
  // Документ раскрытой обложки строится только на раскрытии: он несёт весь `r10.css`.
  const coverPage = useMemo(() => (coverOpen ? coverPageDoc(passport) : null), [coverOpen, passport]);
  const toggleCover = useCallback(() => setCoverOpen((o) => !o), []);
  // Паспорт — из памяти шага, не из ключа: после `sent: true` ключ стёрт, а документ открывается.
  const docUrl = useRef(null);
  const onOpen = useCallback(() => {
    // До ответа судьи Open сборку не заказывает (иначе она и стала бы той первой без цитат) — только кнопку.
    docUrl.current = openDocument(passport, docUrl.current, globalThis, pdf, { build: judged });
  }, [passport, pdf, judged]);
  return (
    <StepSevenScreen
      cover={cover} coverReady={coverReady} onCoverLoad={onCoverLoad} field={field} delivery={delivery}
      coverOpen={coverOpen} coverPage={coverPage} onToggleCover={toggleCover} onOpen={onOpen}
    />
  );
}

/**
 * Отправка шага 7: слепок → письмо. Никогда не бросает. Адреса сервиса письма нет — ничего не
 * сохраняется (строка без письма никому не нужна), исход тот же `no_endpoint`, что и раньше.
 *
 * @param {{email:string, idempotencyKey:string}} input
 * @param {object} passport паспорт шага — его же рисует Open
 * @param {{current: null|{passport:object, token:string, generatedAt:string}}} share память шага
 */
export async function sendWithSnapshot(input, passport, share, deps = {}) {
  const endpoint = deps.endpoint !== undefined ? deps.endpoint : sendEndpoint();
  if (!endpoint) return { sent: false, reason: 'no_endpoint' };
  if (share.current?.passport !== passport) {
    share.current = { passport, token: newToken(), generatedAt: localIsoDate() };
  }
  const { token, generatedAt } = share.current;
  const saved = await (deps.save ?? saveSnapshot)(token, makeSnapshot(passport, generatedAt));
  if (!saved.saved) return { sent: false, reason: `snapshot_${saved.reason}` };
  return (deps.sendImpl ?? sendPassport)({ ...input, token }, { endpoint });
}

const NO_DELIVERY = { ...IDLE, onSend: () => {}, onChangeAddress: () => {} };

/** Разметка экрана во всех состояниях. Экспортирована ради тестов с подставным полем. */
export function StepSevenScreen({
  cover, field, delivery = NO_DELIVERY, coverOpen = false, coverPage = null, onToggleCover = () => {},
  onOpen = () => {}, coverReady = true, onCoverLoad = () => {},
}) {
  const d = delivery;
  const sendOn = field.status === 'valid';
  // Плита разбора — тап-цель только в received и только с готовой обложкой (E4b: тап погашен).
  const tileLive = d.go && coverReady;
  const failed = d.failing || d.fail;
  const state = failed ? 'failed' : d.sent || d.go ? 'received' : 'gated';
  // Поле — ввод до первого тапа и после «Change»; в остальное время — адрес целиком (`s755.d2`).
  // Возврат (E6/E7) входит уже адресом: поле — ввод только после «Change».
  const fieldIsInput = (d.taps === 0 && !d.returning) || d.editing;
  // E1: строка ошибки и микро-абзац — по статусу поля, пока поле ввод.
  const bad = fieldIsInput && field.status === 'invalid';
  // E6/E7 до «Change»: ни квитанции (нажатия не было), ни send — адрес с «Change» и есть всё (`:57–61`).
  const quietReturn = d.returning && d.taps === 0 && !d.editing;
  // Квитанция стоит на месте send, пока её не забрал отказ или «Change».
  const showReceipt = (d.sent || d.failing) && !d.fail && !d.editing;
  const receipt = showReceipt ? receiptFor(d.address) : null;
  const flags = ['sent', 'go', 'settled', 'failing', 'fail'].filter((k) => d[k]).join(' ');

  const inputRef = useRef(null);
  useEffect(() => {
    if (d.editing && inputRef.current) inputRef.current.focus();
  }, [d.editing]);

  const tileKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onToggleCover();
    }
  };

  return (
    <div data-testid="s7-screen" className={`s7-screen${flags ? ` ${flags}` : ''}`} data-state={state}>
      <div data-testid="s7-eyebrow" className="s7-eyb">{S7_COPY.eyebrow}</div>
      <h2 data-testid="s7-title" className="s7-ttl"><em>{S7_TITLE.em}</em><br />{S7_TITLE.rest}</h2>
      {/* static-hold во ВСЕХ состояниях, включая отказ (`s477.d1`, `s921.d4`): у E2/E6/E7 борд её не
          рисует — это долг борда, не канон. */}
      <p data-testid="s7-exchange" className="s7-deal2">{S7_COPY.exchange}</p>

      <div data-testid="s7-where" className="s7-blk">
        <div className="s7-blk-lb"><span>{S7_COPY['where_to.label']}</span></div>
        <div className="s7-fieldrow">
          {/* `key` по числу тапов — пульс (`animation` один раз) переигрывается на повторной отправке. */}
          <div key={`f${d.taps}`} data-testid="s7-field" data-status={field.status}
            className={`s7-field${field.status === 'valid' ? ' ok' : ''}${bad ? ' bad' : ''}`}>
            {fieldIsInput ? (
              <>
              <input
                ref={inputRef}
                data-testid="s7-email"
                type="email"
                inputMode="email"
                autoComplete="email"
                spellCheck={false}
                aria-label={S7_COPY['where_to.label']}
                placeholder={S7_COPY['email_field.placeholder']}
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                aria-invalid={bad || undefined}
                aria-describedby={bad ? 's7-err-email' : undefined}
              />
              {bad && <span data-testid="s7-field-bad" className="tick bad" aria-hidden="true">✕</span>}
              </>
            ) : (
              <>
                {/* received: полный адрес, без маски (`s755.d2`), инертно, без каретки (§3). */}
                <span data-testid="s7-email-value" className="val">{d.address}</span>
                {d.sent && !d.settled
                  ? <span data-testid="s7-field-tick" className="tick">✓</span>
                  : (
                    <button type="button" data-testid="s7-change" className="edit" onClick={d.onChangeAddress}>
                      {S7_COPY['email_field.change']}
                    </button>
                  )}
              </>
            )}
          </div>
        </div>
        {bad && (
          <>
            <p id="s7-err-email" data-testid="s7-err-email" className="s7-err-l">{S7_COPY['err.email']}</p>
            <p data-testid="s7-microcopy" className="s7-micro">{S7_COPY['where_to.microcopy']}</p>
          </>
        )}
        {!quietReturn && (
        <div data-testid="s7-sendslot" className="s7-sendslot">
          {showReceipt ? (
            <>
              <div data-testid="s7-receipt" className="s7-receipt">
                <span className="tk">✓</span>
                <span data-testid="s7-receipt-line" className="rl">{receipt}</span>
                <span className="rt">{S7_COPY['sent.time']}</span>
              </div>
              <p data-testid="s7-spam" className="s7-spam">{S7_COPY['sent.spam']}</p>
            </>
          ) : (
            // `off` — класс `dim` борда (`a.cta.dim`, edge v9; §4 «`dim` — класс реализации `off`»).
            // После отказа и после «Change» — ТОТ ЖЕ контрол, что до тапа: ретрай = он же (`s921.d1`).
            <button type="button" data-testid="s7-send" data-state={sendOn ? 'on' : 'off'}
              className={`s7-cta send${sendOn ? '' : ' dim'}`} disabled={!sendOn} onClick={d.onSend}>
              {S7_COPY['primary.send']} <span>→</span>
            </button>
          )}
        </div>
        )}
      </div>

      <div data-testid="s7-open-blk" className="s7-blk">
        {failed && (
          // ЕДИНСТВЕННЫЙ сдвиг экрана (`s921.d3`, вариант A): строка раскрывается своей высотой над
          // Open, низ уезжает вниз один раз. Узел встаёт на `failing`, раскрывается на `fail`.
          <div data-testid="s7-err-send" className={`s7-errwrap${d.fail ? ' on' : ''}`}>
            <p className="s7-sent-p s7-errp">
              <span className="hd">{S7_COPY['err.send.hd']}</span> {S7_COPY['err.send.sub']}
            </p>
          </div>
        )}
        <button type="button" data-testid="s7-open" data-state={d.go ? 'live' : 'locked'}
          className="s7-cta open" disabled={!d.go} onClick={onOpen}>
          {S7_COPY.open_cta} <span>→</span>
        </button>
        <p data-testid="s7-open-sub" className="s7-micro center">{S7_COPY['open.sub']}</p>
      </div>

      <div data-testid="s7-get" className="s7-unlock">
        <div className="s7-blk-lb">
          <span>{S7_COPY['get.lb']}</span>
          <span data-testid="s7-get-chip" className={d.go ? 'ok-lb' : 'lock'}>
            {d.go ? S7_COPY['get.lb.chip.yours'] : S7_COPY['get.lb.chip']}
          </span>
        </div>
        <div className="s7-objwrap">
          <div data-testid="s7-obj-reading" className={`s7-obj${coverReady ? '' : ' wait'}`}
            data-cover={coverReady ? 'ready' : 'pending'}
            {...(tileLive ? {
              role: 'button', tabIndex: 0, 'aria-expanded': coverOpen, onClick: onToggleCover, onKeyDown: tileKey,
            } : {})}>
            <div className="s7-stack">
              <span className="sh sh1" /><span className="sh sh2" />
              <div className={`s7-thumb${coverReady ? '' : ' blank'}`}>
                {/* Фрейм не контрол: тап ловит вся плита. Вне обхода табом и читалки. До загрузки —
                    невидим (E4b): обложка появляется уже готовой, на глазах не собирается. */}
                <iframe data-testid="s7-cover" title="" aria-hidden="true" tabIndex={-1} srcDoc={cover}
                  onLoad={onCoverLoad} />
                {tileLive && <span data-testid="s7-tap" className="tap">{S7_COPY['obj.reading.tap']}</span>}
              </div>
            </div>
            <div className="s7-objm">
              <span className="st">{S7_COPY['obj.reading.count']}</span>
              <div className="n">{S7_COPY['obj.reading.name']}</div>
              <div className="d">{S7_COPY['obj.reading.desc']}</div>
              {!coverReady && <span data-testid="s7-cover-pending" className="wt">{S7_COPY['pending.cover']}</span>}
            </div>
          </div>
          {/* Карточка: gated — locked с ценой; received — инертна (E10, `s478.d4`): тёмные Save/Share
              без обработчика и вне фокуса, тап — тишина. */}
          <div data-testid="s7-obj-card" className={`s7-obj card inert${d.go ? '' : ' locked'}`}>
            <div className="obj-in">
              <div className="s7-thumb ph" />
              <div className="s7-objm">
                <div className="n">{S7_COPY['card.name']}</div>
                <div className="d">{S7_COPY['obj.card.desc']}</div>
              </div>
            </div>
            {d.go ? (
              <>
                <div data-testid="s7-card-acts" className="s7-acts dead">
                  <span>{S7_COPY['card.save']}</span><span>{S7_COPY['card.share']}</span>
                </div>
                <p data-testid="s7-card-inert" className="s7-inert-l">{S7_COPY['card.inert']}</p>
              </>
            ) : (
              <div data-testid="s7-card-acts" className="s7-acts locked dead"><span>{S7_COPY['get.lb.chip']}</span></div>
            )}
          </div>
          <span data-testid="s7-scrim" className="s7-scrim" />
        </div>
        {tileLive && coverOpen && (
          // COVER PREVIEW (§5): в потоке, не модалка; одна страница §I во всю ширину, без скролла и
          // листания, амбер-кнопка прямо под ней. Шапку вьюера борда (`i · cover` / `close`) и лейблы
          // `the cover` / `[ §i of vii ]` в §3 нет — не печатаются; закрывает повторный тап по плите.
          <>
            <div data-testid="s7-cover-preview" className="s7-viewer">
              <div className="s7-cover-plate">
                <iframe data-testid="s7-cover-page" title="" aria-hidden="true" tabIndex={-1} srcDoc={coverPage ?? ''} />
              </div>
              <p data-testid="s7-cover-note" className="s7-micro">{S7_COPY['cover.note']}</p>
            </div>
            <div className="s7-blk">
              <button type="button" data-testid="s7-cover-open" className="s7-cta" onClick={onOpen}>
                {S7_COPY.open_cta} <span>→</span>
              </button>
              <p className="s7-micro center">{S7_COPY['open.sub']}</p>
            </div>
          </>
        )}
      </div>

      {d.go && (
        // Мост — только после выдачи (`s472.d5`), за 34 px до него (§10, `.bridge{margin-top:34px}`).
        <div data-testid="s7-bridge" className="s7-bridge">
          <p>{S7_COPY['bridge.line']}</p>
          <a className="quiet" href={BRIDGE_HREF}>{S7_COPY['bridge.cta']} <span>→</span></a>
        </div>
      )}
    </div>
  );
}
